import React from 'react';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import MsgNetLoading from '../components/MsgNetLoading';
import EventoList from '../components/EventoList';
import CONFIG from '../config';

let firebaseDb = null;
if (CONFIG.FIREBASE_APIKEY) {
  const app = initializeApp({
    apiKey: CONFIG.FIREBASE_APIKEY,
    appId: CONFIG.FIREBASE_APPID,
    projectId: CONFIG.FIREBASE_PROJECTID
  });
  firebaseDb = getFirestore(app);
}

class EventoListScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventosApi: [],
      eventosFirebase: [],
      apiLoaded: false,
      firebaseLoaded: false
    };
    this._unmounted = false;
    this._ws = null;
    this._unlistenFb = null;
  }

  componentDidMount() {
    this.fetchEventos();
    this._connectWS();
    this._connectFirebase();
  }

  _connectWS() {
    if (this._unmounted) return;
    const ws = new WebSocket(`${CONFIG.WS_URL}/ws/0`);
    this._ws = ws;
    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        if (msg.tipo === 'eventos_update') this.fetchEventos();
      } catch (_) {}
    };
    ws.onclose = () => {
      this._ws = null;
      if (!this._unmounted) setTimeout(() => this._connectWS(), 2000);
    };
    ws.onerror = () => ws.close();
  }

  _connectFirebase() {
    if (!firebaseDb) {
      this.setState({ firebaseLoaded: true });
      return;
    }
    const eventosQuery = query(
      collection(firebaseDb, 'evento'),
      where('visible', '==', true),
      orderBy('fecha_inicio'),
      orderBy('hora_inicio')
    );
    this._unlistenFb = onSnapshot(eventosQuery, (snapshot) => {
      const eventos = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        _href: `${CONFIG.LIVE1_BASE_URL}/${doc.id}`
      }));
      this.setState({ eventosFirebase: eventos, firebaseLoaded: true });
    }, (err) => {
      console.error('firebase eventos error:', err);
      this.setState({ firebaseLoaded: true });
    });
  }

  componentWillUnmount() {
    this._unmounted = true;
    if (this._ws) { this._ws.close(); this._ws = null; }
    if (this._unlistenFb) this._unlistenFb();
  }

  fetchEventos() {
    fetch(`${CONFIG.API_URL}/api/1.0/live/eventos/`)
      .then(r => r.json())
      .then(eventos => this.setState({ eventosApi: eventos, apiLoaded: true }))
      .catch(err => {
        console.error('api eventos error:', err);
        this.setState({ apiLoaded: true });
      });
  }

  _mergeEventos() {
    const { eventosApi, eventosFirebase } = this.state;
    const apiKeys = new Set(eventosApi.map(e => e.nombre + '_' + e.fecha_inicio));
    const uniqueFb = eventosFirebase.filter(e => !apiKeys.has(e.nombre + '_' + e.fecha_inicio));
    const merged = [...eventosApi, ...uniqueFb];
    merged.sort((a, b) => (a.fecha_inicio || '').localeCompare(b.fecha_inicio || ''));
    return merged;
  }

  render() {
    if (!this.state.apiLoaded && !this.state.firebaseLoaded) {
      return <MsgNetLoading />;
    }
    return <EventoList eventos={this._mergeEventos()} />;
  }
}

function EventoListScreen() {
  return <EventoListScreenClass />;
}

export default EventoListScreen;
